import { Box, List, ListItem, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CandidateData = () => {
  return (
    <Box
      sx={{
        overflow: "hidden", 
        overflowX: "hidden", // Ensures no horizontal scrolling
        maxWidth: "100%", // Keeps content within the container
        pl: { xs: "0.5rem", sm: "0.75rem", md: "1rem", lg: 0 },
        pt: { xs: "1rem", sm: "2.5rem", md: "2.5rem", lg: "2rem" },
        pb: 0,
        mt:{xs:"1rem"}
      }}
    >
      <List sx={{ pl: 4 }}>
        <ListItem sx={{ pl: 0, mb: 0, pb: 0 }}>
          <CheckCircleIcon sx={{ color: "green", mr: 1, fontSize: "12px" }} />
          <Typography
            sx={{ fontSize: "12px", fontWeight: "600", mb: 0, mt: "-6px" }}
          >
            Resumes ≠ Reality
          </Typography>
        </ListItem>
        <List sx={{ listStyleType: "disc", mt: "-4px", p: 0, pl: 4 }}>
          <ListItem
            sx={{
              display: "list-item",
              pl: 0,
              "&::marker": { fontSize: "1em" },
            }}
          >
            <Typography sx={{ fontSize: "11px", mb: 0 }}>
              Job descriptions list the ideal candidate, but resumes reflect
              past experience—AI finds the closest fit, not just a keyword
              match.
            </Typography>
          </ListItem>
        </List>
        <ListItem sx={{ pl: 0, mb: 0, pb: 0 }}>
          <CheckCircleIcon sx={{ color: "green", mr: 1, fontSize: "12px" }} />
          <Typography sx={{ fontSize: "12px", fontWeight: "600", mb: 0 }}>
            Skills Alone Don’t Define a Great Hire
          </Typography>
        </ListItem>
        <List sx={{ listStyleType: "disc", mt: "-4px", p: 0, pl: 4 }}>
          <ListItem
            sx={{
              display: "list-item",
              pl: 0,
              "&::marker": { fontSize: "1em" },
            }}
          >
            <Typography sx={{ fontSize: "11px", mb: 0 }}>
              Soft skills, adaptability, and cultural fit can’t be reduced to
              numbers—your judgment makes the final call.
            </Typography>
          </ListItem>
        </List>
        <ListItem sx={{ pl: 0, mb: 0, pb: 0 }}>
          <CheckCircleIcon sx={{ color: "green", mr: 1, fontSize: "12px" }} />
          <Typography
            sx={{ fontSize: "12px", fontWeight: "600", mb: 0, mt: "-6px" }}
          >
            The Right Candidate Might Look Different on Paper
          </Typography>
        </ListItem>
        <List sx={{ listStyleType: "disc", mt: "-4px", p: 0, pl: 4 }}>
          <ListItem
            sx={{
              display: "list-item",
              pl: 0,
              "&::marker": { fontSize: "1em" },
            }}
          >
            <Typography sx={{ fontSize: "11px", mb: 0 }}>
              AI identifies potential beyond rigid checklists, ensuring you
              don’t miss a great hire just because they don’t check every box.
            </Typography>
          </ListItem>
        </List>
        <ListItem sx={{ pl: 0, mb: 0, pb: 0 }}>
          <CheckCircleIcon sx={{ color: "green", mr: 1, fontSize: "12px" }} />
          <Typography
            sx={{ fontSize: "12px", fontWeight: "600", mb: 0, mt: "-6px" }}
          >
            AI Helps You Hire Smarter, Not Replace Decision-Making
          </Typography>
        </ListItem>
        <List sx={{ listStyleType: "disc", mt: "-4px", p: 0, pl: 4 }}>
          <ListItem
            sx={{
              display: "list-item",
              pl: 0,
              "&::marker": { fontSize: "1em" },
            }}
          >
            <Typography sx={{ fontSize: "11px", mb: 0, mt: 0 }}>
              Our goal isn’t to hit 100%—it’s to surface the right talent
              faster, so you can focus on what matters: hiring the best people,
              not just the best resumes.
            </Typography>
          </ListItem>
        </List>
        <List sx={{ pl: 4, mt: "-10px" ,marginTop:"-12px"}}>
          <ListItem sx={{ pl: 0 }}>
            <Typography sx={{ fontSize: "12px", fontWeight: "600", p: 0 }}>
              Let AI do the heavy lifting—so you can make hiring decisions with
              confidence.
            </Typography>
          </ListItem>
        </List>
      </List>
    </Box>
  );
};
export default CandidateData;
